export class BaseEmail {
  to: string[];
  from: string;
  subject: string;
  text: string;
  html: string;
  body: { [key: string]: string };
}
